import { FC } from 'react';

import Image from './image.png';

export const CollectionsImage: FC = () => <img src={Image} alt="collections" />;
